import { createSelector } from 'reselect';
import type { ICustomerBase } from '../../api/domain';
import type { IRootState } from '../root-reducer';

export const getCustomerBases = (state: IRootState) => state.customerBaseApi.customerBases;
export const getDefaultCustomerBase = (state: IRootState) => state.customerBaseApi.defaultCustomerBase;
export const getOwnCustomerBase = (state: IRootState) => state?.customerBaseApi?.customerBases?.find((customerBase) => !!customerBase.isSource);

export const getOrderedCustomerBases: (state: IRootState) => ICustomerBase[] = createSelector(
    getCustomerBases,
    getOwnCustomerBase,
    (customerBases: ICustomerBase[] = [], ownCustomerBase?: ICustomerBase) => {
        if (!ownCustomerBase) {
            return [...customerBases].sort(({ displayName: cbNameA }, { displayName: cbNameB }) => cbNameA.localeCompare(cbNameB));
        }

        const otherCustomerBases = customerBases.filter((cb) => cb.externalId !== ownCustomerBase.externalId);
        const sortedCustomerBases = [...otherCustomerBases].sort(({ displayName: cbNameA }, { displayName: cbNameB }) => cbNameA.localeCompare(cbNameB));
        const containsOwnCustomerBase = otherCustomerBases.length < customerBases.length;

        return containsOwnCustomerBase ? [ownCustomerBase, ...sortedCustomerBases] : sortedCustomerBases;
    },
);
